import { render, staticRenderFns } from "./LayoutKyc.vue?vue&type=template&id=09f85bc2"
import script from "./LayoutKyc.vue?vue&type=script&lang=js"
export * from "./LayoutKyc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports